import { useState } from 'react'
import IPricingFeature from 'models/IPricingFeature'

export enum PricingPlans {
  FreePlan = 'free',
  PlusPlan = 'plus',
  ProPlan = 'pro',
}

export interface PricingProps {}

export const usePricing = (props: PricingProps) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState<PricingPlans>(
    PricingPlans.FreePlan
  )

  const freePlanFeatures: IPricingFeature[] = [
    {
      content: '1 Category',
      isProvided: true,
    },
    {
      content: 'Up to 3 sub-categories',
      isProvided: true,
    },
    {
      content: 'Up to 8 items per sub-category',
      isProvided: true,
    },
    {
      content:
        'Restaurant info (Location, Phone, Currency, Wi-Fi Password, Description)',
      isProvided: true,
    },
    {
      content: 'Custom logo and background',
      isProvided: true,
    },
    {
      content: 'Custom color palette',
      isProvided: false,
    },
    {
      content: 'Display nutritions',
      isProvided: false,
    },
    {
      content: 'Ingredients list',
      isProvided: false,
    },
    {
      content: 'Opening hours',
      isProvided: false,
    },
    {
      content: 'Restaurant feedback',
      isProvided: false,
    },
    {
      content: 'Experience rating',
      isProvided: false,
    },
    {
      content: 'Smart Delivery Manager',
      isProvided: false,
    },
    {
      content: 'Multi-branch support',
      isProvided: false,
    },
    {
      content: 'AI menu assistant',
      isProvided: false,
    },
  ]

  const plusPlanFeatures: IPricingFeature[] = [
    {
      content: 'Unlimited categories',
      isProvided: true,
    },
    {
      content: 'Unlimited sub-categories',
      isProvided: true,
    },
    {
      content: 'Unlimited items per sub-category',
      isProvided: true,
    },
    {
      content:
        'Restaurant info (Location, Phone, Currency, Wi-Fi Password, Description)',
      isProvided: true,
    },
    {
      content: 'Custom logo and background',
      isProvided: true,
    },
    {
      content: 'Custom color palette',
      isProvided: true,
    },
    {
      content: 'Display nutritions',
      isProvided: true,
    },
    {
      content: 'Ingredients list',
      isProvided: true,
    },
    {
      content: 'Opening hours',
      isProvided: true,
    },
    {
      content: 'Restaurant feedback',
      isProvided: true,
    },
    {
      content: 'Experience rating',
      isProvided: true,
    },
    {
      content: 'Smart Delivery Manager',
      isProvided: true,
    },
    {
      content: 'Multi-branch support',
      isProvided: false,
    },
    {
      content: 'AI menu assistant',
      isProvided: false,
    },
  ]

  const proPlanFeatures: IPricingFeature[] = [
    {
      content: 'Unlimited categories',
      isProvided: true,
    },
    {
      content: 'Unlimited sub-categories',
      isProvided: true,
    },
    {
      content: 'Unlimited items per sub-category',
      isProvided: true,
    },
    {
      content:
        'Restaurant info (Location, Phone, Currency, Wi-Fi Password, Description)',
      isProvided: true,
    },
    {
      content: 'Custom logo and background',
      isProvided: true,
    },
    {
      content: 'Custom color palette',
      isProvided: true,
    },
    {
      content: 'Display nutritions',
      isProvided: true,
    },
    {
      content: 'Ingredients list',
      isProvided: true,
    },
    {
      content: 'Opening hours',
      isProvided: true,
    },
    {
      content: 'Restaurant feedback',
      isProvided: true,
    },
    {
      content: 'Experience rating',
      isProvided: true,
    },
    {
      content: 'Smart Delivery Manager',
      isProvided: true,
    },
    {
      content: 'Multi-branch support',
      isProvided: true,
    },
    {
      content: 'AI menu assistant',
      isProvided: true,
      isSoon: true,
    },
  ]

  const handleSubscribeClick = (plan: PricingPlans) => {
    setShowModal(true)
    setSelectedPlan(plan)
  }

  const handlePlanChange = (plan: PricingPlans) => {
    setSelectedPlan(plan)
  }

  return {
    ...props,
    showModal,
    freePlanFeatures,
    plusPlanFeatures,
    proPlanFeatures,
    selectedPlan,
    setShowModal,
    handleSubscribeClick,
    handlePlanChange,
  }
}
